module.exports = __webpack_public_path__ + "static/media/2 (23).af81dd95.jpg";